export default __webpack_public_path__ + "static/media/defaultUserBackground.9b0e6607.jpg";